import getPageLocalesData from '@src/global-locales/get-page-locales-data';
const pageLocalesData = getPageLocalesData();
const textInfo = pageLocalesData.main.thirdSection;

export default [
  {
    title: 'PVE',
    info: '战舰战',
    bgImgs: require('./images/img1.png'),
    tabCoverImgs: require('./images/tab-cover1.jpg'),
    ...textInfo[0]
  },
  {
    title: '战利品',
    info: '占位',
    bgImgs: require('./images/img2.png'),
    tabCoverImgs: require('./images/tab-cover2.jpg'),
    ...textInfo[1]
  },
  {
    title: '撤离',
    info: '占位',
    bgImgs: require('./images/img3.png'),
    tabCoverImgs: require('./images/tab-cover3.jpg'),
    ...textInfo[2]
  },
  {
    title: '使命',
    info: '占位',
    bgImgs: require('./images/img4.png'),
    tabCoverImgs: require('./images/tab-cover4.jpg'),
    ...textInfo[3]
  },
  {
    title: '自定义武装',
    info: '占位',
    bgImgs: require('./images/img5.png'),
    tabCoverImgs: require('./images/tab-cover5.jpg'),
    ...textInfo[4]
  },
  {
    title: '超大战场',
    info: '占位',
    bgImgs: require('./images/img6.png'),
    tabCoverImgs: require('./images/tab-cover6.jpg'),
    ...textInfo[5]
  }
];
